export default {
  pt: {
    'cadastros.eixos.abrir': 'Importar eixos',
    'cadastros.eixos.titulo': 'Importar eixos da frota',
    'cadastros.eixos.instrucao': 'Um CSV com placa e eixos, separados por ponto e vírgula, e uma terceira coluna opcional com os eixos levantáveis, de 0 a 4. Em branco, ela não muda o cadastro. O arquivo vai primeiro em prévia, e nada é gravado até você confirmar.',
    'cadastros.eixos.escolher': 'Escolher arquivo CSV',
    'cadastros.eixos.linhas': 'Linhas',
    'cadastros.eixos.alteradas': 'Mudam',
    'cadastros.eixos.iguais': 'Já iguais',
    'cadastros.eixos.problemas': 'Com problema',
    'cadastros.eixos.semCadastro': 'Placas sem cadastro na frota',
    'cadastros.eixos.ambiguas': 'Placas que casam com mais de um veículo',
    'cadastros.eixos.repetidas': 'Placas repetidas com eixos diferentes',
    'cadastros.eixos.invalidas': 'Linhas inválidas',
    'cadastros.eixos.linhaN': 'linha {{n}} {{placa}}',
    'cadastros.eixos.gravar': 'Gravar {{n}} veículos',
    'cadastros.eixos.gravado': 'Eixos gravados em {{n}} veículos.',
    'cadastros.eixos.campo': 'Eixos',
  },
  en: {
    'cadastros.eixos.abrir': 'Import axles',
    'cadastros.eixos.titulo': 'Import fleet axles',
    'cadastros.eixos.instrucao': 'A CSV with plate and axles, separated by semicolons, and an optional third column with the liftable axles, from 0 to 4. Left blank, it does not change the registry. The file goes into a preview first, and nothing is saved until you confirm.',
    'cadastros.eixos.escolher': 'Choose CSV file',
    'cadastros.eixos.linhas': 'Rows',
    'cadastros.eixos.alteradas': 'Change',
    'cadastros.eixos.iguais': 'Already equal',
    'cadastros.eixos.problemas': 'With issues',
    'cadastros.eixos.semCadastro': 'Plates not in the fleet',
    'cadastros.eixos.ambiguas': 'Plates matching more than one vehicle',
    'cadastros.eixos.repetidas': 'Repeated plates with different axles',
    'cadastros.eixos.invalidas': 'Invalid rows',
    'cadastros.eixos.linhaN': 'row {{n}} {{placa}}',
    'cadastros.eixos.gravar': 'Save {{n}} vehicles',
    'cadastros.eixos.gravado': 'Axles saved on {{n}} vehicles.',
    'cadastros.eixos.campo': 'Axles',
  },
  es: {
    'cadastros.eixos.abrir': 'Importar ejes',
    'cadastros.eixos.titulo': 'Importar ejes de la flota',
    'cadastros.eixos.instrucao': 'Un CSV con placa y ejes, separados por punto y coma, y una tercera columna opcional con los ejes levantables, de 0 a 4. En blanco, no cambia el registro. El archivo va primero en vista previa, y nada se guarda hasta que usted confirme.',
    'cadastros.eixos.escolher': 'Elegir archivo CSV',
    'cadastros.eixos.linhas': 'Líneas',
    'cadastros.eixos.alteradas': 'Cambian',
    'cadastros.eixos.iguais': 'Ya iguales',
    'cadastros.eixos.problemas': 'Con problema',
    'cadastros.eixos.semCadastro': 'Placas sin registro en la flota',
    'cadastros.eixos.ambiguas': 'Placas que coinciden con más de un vehículo',
    'cadastros.eixos.repetidas': 'Placas repetidas con ejes distintos',
    'cadastros.eixos.invalidas': 'Líneas inválidas',
    'cadastros.eixos.linhaN': 'línea {{n}} {{placa}}',
    'cadastros.eixos.gravar': 'Guardar {{n}} vehículos',
    'cadastros.eixos.gravado': 'Ejes guardados en {{n}} vehículos.',
    'cadastros.eixos.campo': 'Ejes',
  },
}
